import { createContext, useState } from "react";
import { GlobalContextInterface, User } from "./globalContextTypes";

export const GlobalContext = createContext<GlobalContextInterface>({
  setUser: () => {},
  user: { isAdmin: false, token: "" },
  errorsQtty: 0,
  setErrorsQtty: () => {},
  apiAccessToken: "",
  setApiAccessToken: () => {},
});

export const GlobalContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [errorsQtty, setErrorsQtty] = useState<number>(0);
  const [user, setUser] = useState<User>({ isAdmin: false, token: "" });
  const [apiAccessToken, setApiAccessToken] = useState<string>("");

  return (
    <GlobalContext.Provider
      value={{
        errorsQtty,
        setErrorsQtty,
        user,
        setUser,
        apiAccessToken,
        setApiAccessToken,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
